export default __webpack_public_path__ + "assets/images/6c2f0bfe3a6780d401165c3aadd14e2e.webp";